import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from 'src/app/data/services/product.service';
import { CartService } from 'src/app/data/services/cart.service';
import { Helper } from 'src/app/shared/helper';
import { ToastService } from 'src/app/data/services/toastr.service';

@Component({
  selector: 'app-product-detail-modal',
  templateUrl: './product-detail-modal.component.html',
  styleUrl: './product-detail-modal.component.scss'
})
export class ProductDetailModalComponent {
  modalRef!: NgbModalRef;
  modalConfig = {
    centered: true,
    ariaLabelledBy: 'modal-basic-title',
    size: 'xl',
    windowClass: 'product-detail-modal-window',
  };
  @ViewChild('template', { static: true }) template!: TemplateRef<any>;
  allImages: string[] = [];
  selectedImage: string | null = null;
  orderQuantity = 1;
  isAddingToCart = false;
  product = {
    _id: "",
    profileImage: "",
    images: [],
    tags: "",
    sortOrder: 0,
    quantity: 0,
    price: 0,
    discount: 0,
    name: "",
    description: "",
    category: [{
      name: '',
      _id: ''
    }]
  };
  constructor(
    private modalService: NgbModal,
    public helper: Helper,
    private productService: ProductService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) { }
  selectImage(image: string): void {
    this.selectedImage = image;
  }

  get displayImage(): string {
    return this.selectedImage || this.allImages[0] || this.helper.DEFAULT_LOGO;
  }

  get hasDiscount(): boolean {
    return !!this.product.discount && this.product.discount > 0;
  }

  get discountedPrice(): number {
    return this.helper.getDiscountedPrice(this.product.price, this.product.discount);
  }

  get categoryName(): string {
    return this.product.category?.[0]?.name || '';
  }

  t(key: string, fallback: string): string {
    const translated = this.helper.trans.instant(key);
    return translated && translated !== key ? translated : fallback;
  }

  increaseQuantity(): void {
    const maxQuantity = Number(this.product.quantity ?? 1);
    this.orderQuantity = Math.min(maxQuantity > 0 ? maxQuantity : 1, Number(this.orderQuantity) + 1);
  }

  decreaseQuantity(): void {
    this.orderQuantity = Math.max(1, Number(this.orderQuantity) - 1);
  }
  async open(productId: string) {
    await this.getProductDetails(productId);
    this.orderQuantity = 1;
    this.modalRef = this.modalService.open(this.template, this.modalConfig);
  }

  getProductDetails(productId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const parameters = { useLocalizedFields: true };
      if (productId) {
        this.productService.getproductDetail(productId, parameters).subscribe(
          (res: any) => {
            if (res && res.data && res.data.length > 0) {
              this.product = res.data[0];

              // Combine profileImage and other images into allImages
              this.allImages = [this.product.profileImage, ...(this.product.images || [])].filter((image): image is string => !!image);
              this.selectedImage = this.allImages[0] ?? null; // Set the default selected image

              resolve();  // Resolve the promise once data is fetched successfully
            } else {
              resolve();
            }
          },
          (error) => {
            resolve();
          }
        );
      }
    });
  }

  notifyProduct():void{
    if (!this.helper.userDetails?._id) {
      this.toastService.showToast('warning', this.helper.trans.instant('validation-title.login-before-notification'));
      return;
    }

  const param = {customerId:this.helper.userDetails._id,categoryId:this.product.category[0]?._id,productId:this.product._id}
    this.productService.notifyProduct(param).subscribe((res: any) => {
      if(res){
        console.log(res);

        
      }
    });
  }

  addToCart(): void {
    if (!this.helper.userDetails?._id) {
      this.toastService.showToast('warning', this.helper.trans.instant('validation-title.login-before-order'));
      return;
    }

    const quantity = Number(this.orderQuantity);
    if (!quantity || quantity < 1) {
      this.toastService.showToast('warning', this.helper.trans.instant('validation-title.order-quantity-at-least-one'));
      return;
    }

    const availableQuantity = Number(this.product.quantity ?? 0);
    if (availableQuantity <= 0) {
      this.toastService.showToast('warning', this.helper.trans.instant('validation-title.product-out-of-stock'));
      return;
    }

    if (quantity > availableQuantity) {
      this.toastService.showToast('warning', this.helper.trans.instant('validation-title.requested-quantity-not-available'));
      return;
    }

    this.isAddingToCart = true;
    this.cartService.addItem({
      productId: this.product._id,
      productName: this.product.name,
      productImage: this.product.profileImage,
      categoryName: this.product.category?.[0]?.name || '',
      price: Number(this.product.price || 0),
      discount: Number(this.product.discount || 0),
      quantity,
      availableQuantity,
    });
    this.isAddingToCart = false;
    this.toastService.showToast('success', this.helper.trans.instant('validation-title.item-added-to-cart'));
    this.modalRef?.close();
    this.helper._route.navigate(['/app/cart']);
  }
}
